import script from "./TeacherMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherMenu.vue?vue&type=script&setup=true&lang=js"

import "./TeacherMenu.vue?vue&type=style&index=0&id=12fa2705&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12fa2705"]])

export default __exports__